import { Injectable } from '@angular/core';

import { TemplatePortal } from '@angular/cdk/portal';

@Injectable({ providedIn: 'root' })
export class PortalRegistryService {
  private portals = new Map<string, TemplatePortal>();

  set(key: string, portal: TemplatePortal): void {
    this.portals.set(key, portal);
  }

  get(key: string): TemplatePortal | undefined {
    return this.portals.get(key);
  }

  clear(key: string): void {
    this.portals.delete(key);
  }

  clearAll(): void {
    this.portals.clear();
  }
}
